import { render, staticRenderFns } from "./addmin.vue?vue&type=template&id=17c02a76&scoped=true"
import script from "./addmin.vue?vue&type=script&lang=js"
export * from "./addmin.vue?vue&type=script&lang=js"
import style0 from "./addmin.vue?vue&type=style&index=0&id=17c02a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c02a76",
  null
  
)

export default component.exports